import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AppsIcon from '@mui/icons-material/Apps';

import './navigation-bar.css';

class NavigationBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      styles: {
        mediumIcon: {
          width: 36,
          height: 36,
        },
        medium: {
          width: 60,
          height: 60
        }
      }
    };
  }

  _preventTransition(event) {
    event.preventDefault();
  }

  _renderButtonJSXPart(data, Icon) {
    const title = (data.isDisabled) ? '' : data.tooltip;
    // TODO: className='little-grow-animation' or buttons animation 

    return (
      <Link 
        to={data.link}
        title={title}
        onClick={data.isDisabled ? this._preventTransition : null}>
          <IconButton 
            disabled={data.isDisabled}
            touch={true}
            iconStyle={this.state.styles.mediumIcon} 
            style={this.state.styles.medium}>
              <Icon />
          </IconButton>
      </Link>      
    )
  }

  render() {
    return (
      <div className='navigation-bar'>
        {this._renderButtonJSXPart(this.props.previous, ChevronLeftIcon)}
        {this._renderButtonJSXPart(this.props.all, AppsIcon)}
        {this._renderButtonJSXPart(this.props.next, ChevronRightIcon)}
      </div>
    );
  }  
}

const prevNextPropTypes = {
  link: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  isDisabled: PropTypes.boolean
};

NavigationBar.propTypes = {
  previous: PropTypes.shape(prevNextPropTypes),
  next: PropTypes.shape(prevNextPropTypes),
  all: PropTypes.shape(prevNextPropTypes)
}

export default NavigationBar;